import React from 'react'
import { Controller } from 'react-hook-form'
import { Autocomplete } from '@material-ui/lab'
import { TextField } from '@material-ui/core'

const PartnerForm = ({
  control,
  partnersOptions,
  errors,
  label = 'Fornecedor',
}) => {
  return (
    <form>
      <Controller
        as={
          <Autocomplete
            options={partnersOptions}
            getOptionLabel={(option) => option?.name || ''}
            getOptionSelected={(option, value) => option?.id === value?.id}
            filterSelectedOptions
            renderInput={(params) => (
              <TextField
                {...params}
                error={!!errors?.partnerId}
                helperText={errors?.partnerId?.message}
                fullWidth
                variant="outlined"
                label={label}
              />
            )}
          />
        }
        name="partnerId"
        control={control}
        defaultValue={null}
        onChange={([, data]) => data}
        mode="onChange"
      />
    </form>
  )
}

export default PartnerForm
